import React,{ useState, useEffect,useRef, useImperativeHandle, forwardRef } from 'react';
import visaLogo from './visa-logo.png';
import Modal from "../Pages/ChatSetup/components/Modal";
import ConfirmDialog from "../Modal/ConfirmDialog.js";
import {CardForms} from './CardForm';
import billing from "../../api/billing";
import {Dimmer, Loader} from 'semantic-ui-react';
import CancelBillingForm from './CancelBillingForm.js';
import WatchPageTutorial from '../CommonComponents/WatchPageTutorial';
import config from "../../config";
import './billing.css';
import './PlgCancelModal.css';
import { CANCEL_REASONS } from './plgCancelReasons';
const verizonLogo = process.env.PUBLIC_URL + '/assets/media/brand/verizone.png';
const attLogo = process.env.PUBLIC_URL + '/assets/media/brand/allcarrier.png';
const queryString = require("query-string");

const getBillingOverviewRow = (response) => {
    return response?.user_billing_overview?.[0]
        || response?.user_billing_overview_data?.[0]
        || response?.data?.user_billing_overview?.[0]
        || response?.data?.user_billing_overview_data?.[0]
        || null;
};

const isSuccessfulCardAction = (response) => {
    return response?.status === 'done'
        || response?.status === true
        || response?.msg === 'done';
};

const CreditCardList = forwardRef(function CreditCardList( props, ref ){

    console.log('🧪 [CreditCardList] props — isPlgAccount:', props.isPlgAccount, '| isInTrial:', props.isInTrial, '| plgPlan:', props.plgPlan, '| showButtons:', !(props.isPlgAccount && props.isInTrial));

     const cards = props.cardsList.cards;

    //const[cardState,setCardState] = useState({ addCardForm : false, cards : cards});
    const[cardState,setCardState] = useState({ showModal : false, cards : [],user: props.user,showConfirmDialog : false, confirmtitle : "Are You sure to confirm",confirmmessage: "",deletecard:{},loaded:false,loading:false, confirmDialogMode: 'delete' });
    const [showModal, setShowModal] = useState(false);
    const [modelBody, setModelBody] = useState("");
    const [modelTitle, setModelTitle] = useState("");
    const [refresh, doRefresh] = useState(0);
    const [errMsg,seterrMsg]=useState("");
    const [activeTab, setActiveTab] = useState('payment');
    const [billingEmails, setBillingEmails] = useState([]);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [emailInput, setEmailInput] = useState('');
    const [editingEmailId, setEditingEmailId] = useState(null);
    const [emailLoading, setEmailLoading] = useState(false);
    const [showEmailDeleteConfirm, setShowEmailDeleteConfirm] = useState(false);
    const [emailToDelete, setEmailToDelete] = useState(null);
    const [emailError, setEmailError] = useState('');
    const [showPlgCancelModal, setShowPlgCancelModal] = useState(false);
    const [plgCancelInfo, setPlgCancelInfo] = useState(null);
    const [plgCancelInfoLoading, setPlgCancelInfoLoading] = useState(false);
    const [cancelReason, setCancelReason] = useState('');
    const [cancelReasonOther, setCancelReasonOther] = useState('');
    const showCardActionError = (message) => {
        if (props.domref && props.domref.current) {
            props.domref.current.innerHTML = "<div class='alert alert-danger' >" + message + '</div>';
            setTimeout(() => {
                props.domref.current.innerHTML = '';
            }, 3000);
        }
    };

    const setCardsLIst = () => {
        return billing.GetUserBillingDetail({ user_id: props.user.user_id })
            .then((userResp) => {
                if (userResp.cards) {
                    const billingDetail = getBillingOverviewRow(userResp);
                    // overview often returns encrypted card_number; only sync plain last-4
                    // so Mark as primary UI is not wiped after refresh
                    const primaryLastFour = String(billingDetail?.card_number || '');
                    if (/^\d{4}$/.test(primaryLastFour)) {
                        props.changePrimaryCard(
                            primaryLastFour,
                            billingDetail.card_expires_on
                        );
                    }
                    props.updateCards(userResp.cards);
                    setCardState((prev) => ({
                        ...prev,
                        showModal: false,
                        loaded: false,
                        showConfirmDialog: false,
                        confirmDialogMode: 'delete',
                        cards: userResp.cards,
                        loading: false,
                    }));
                    return;
                }

                setCardState((prev) => ({
                    ...prev,
                    showConfirmDialog: false,
                    confirmDialogMode: 'delete',
                    loading: false,
                }));
            })
            .catch(() => {
                setCardState((prev) => ({
                    ...prev,
                    confirmDialogMode: 'delete',
                    loading: false,
                }));
            });
    }
    useEffect(() => {
        const params = queryString.parse(window.location.search);
        if((params.tab !== undefined && params.tab === "billing") && (params.cardSaved !== "undefined" && params.cardSaved ==='1')){
            getlivecards();
        }

    }, []);

    // Fetch billing emails
    const fetchBillingEmails = () => {
        setEmailLoading(true);
        billing.getBillingEmails({})
            .then((response) => {
                if (response && response.status === true && response.data && Array.isArray(response.data)) {
                    // Map API response to component state format
                    const emails = response.data.map((item) => ({
                        id: item.id,
                        email: item.email,
                        status: item.status === "1" || item.status === 1 ? "Active" : "Inactive",
                        is_primary: item.is_primary || "N"
                    }));
                    setBillingEmails(emails);
                } else {
                    setBillingEmails([]);
                }
                setEmailLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching billing emails:', error);
                seterrMsg("Failed to load billing emails.");
                setTimeout(() => {
                    seterrMsg("");
                }, 3000);
                setEmailLoading(false);
            });
    };

    // Fetch emails when billing-emails tab is active
    useEffect(() => {
        if (activeTab === 'billing-emails') {
            fetchBillingEmails();
        }
    }, [activeTab]);

    // Prevent body scroll when modals are open
    useEffect(() => {
        const isAnyModalOpen = showModal || showEmailModal || showEmailDeleteConfirm || cardState.showConfirmDialog || showPlgCancelModal;

        if (isAnyModalOpen) {
            // Save current scroll position
            const scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
        } else {
            // Restore scroll position
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflow = '';
            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        }

        // Cleanup function
        return () => {
            if (!isAnyModalOpen) {
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.width = '';
                document.body.style.overflow = '';
            }
        };
    }, [showModal, showEmailModal, showEmailDeleteConfirm, cardState.showConfirmDialog, showPlgCancelModal]);

    const getlivecards=()=>{
         billing.getZohoUserCards( {user_id:props.user.user_id }).then((userResp) => {
            if(  userResp.msg=="done"){
                console.log("cardsss",userResp);
                props.updateCards( userResp.data );
                setCardState({...cardState,cards:userResp.data});
                props.billing_update();
                window.location = `${config.baseUrl}/settings?tab=billing`;
            }
        });
    }

    const openSetPrimaryConfirm = (card) => {
        setCardState({
            ...cardState,
            showConfirmDialog: true,
            deletecard: card,
            confirmtitle: 'Set Primary Card',
            confirmmessage: 'Are you sure you want to set this card as your primary payment card?',
            confirmDialogMode: 'primary',
        });
        return false;
    };

    const setCardPrimary = (card) => {
        const cardtodel = {
            month: card.expiry_month,
            year: card.expiry_year,
            last_four_digits: card.last_four_digits,
            gateway: 'stripe',
            user: props.user.user_id,
            user_id: props.user.user_id,
            card: card.card_id,
            card_id: card.card_id,
        };
        const expires_on = `${card.expiry_month}/${card.expiry_year}`;
        return billing.makePrimeCard(cardtodel).then((userResp) => {
            if (!isSuccessfulCardAction(userResp)) {
                const message = userResp?.message || userResp?.msg || 'Unable to set primary card. Please try again.';
                throw new Error(message);
            }

            props.changePrimaryCard(card.last_four_digits, expires_on);
            return userResp;
        });
    };

    useEffect(
        () => {

                if( cardState.loaded == false  ){
                    setCardState({
                        ...cardState,
                        cards : props.cardsList,
                        loaded : true
                    })
                }
        },[cardState]
    )
    //delete credit card
    const deleteCreditCard = (e,card,type) => {
        setCardState({
            ...cardState,
            showConfirmDialog: true,
            deletecard: card,
            deleteCrdType: type,
            confirmtitle: 'Remove Non-Primary Card',
            confirmmessage: 'Are you sure you want to remove this non-primary card?',
            deleteCardFlag: false,
            confirmDialogMode: 'delete',
        });
        return false;
    }

    //cardactionbutton starts
    const cardActionButton = ( card ) => {
        const isPrimary = cardState.cards.length === 1 || String(card.last_four_digits) === String(props?.default_card);

        // Primary card — cannot be deleted
        if (isPrimary) return null;

        // Non-primary card — trash icon only
        return (
            <div className="card-action-btns">
                <button
                    onClick={(e) => deleteCreditCard(e, card, "regular")}
                    className="btn card-action-btn card-action-btn--icon card-delete-btn"
                >
                    <i className="fa fa-trash"></i>
                </button>
            </div>
        );
    }
    const closeAddform=()=>{
        setCardState({...cardState,showModal:false,loading:false});
    }
    const cancelBilling=(e)=>{
        if (props.isPlgAccount) {
            const subscriptionId = props.userBillingDetail && props.userBillingDetail.subscription_id;
            if (!subscriptionId) {
                if (props.domref && props.domref.current) {
                    props.domref.current.innerHTML = "<div class='alert alert-warning'>No active subscription to cancel.</div>";
                    setTimeout(() => { props.domref.current.innerHTML = ''; }, 4000);
                }
                return;
            }
            setPlgCancelInfoLoading(true);
            billing.plgCancelInfo({ user_id: props.user.user_id })
                .then((resp) => {
                    setPlgCancelInfoLoading(false);
                    if (resp && resp.status) {
                        if(resp.cancellation_details){
                            if (props.domref && props.domref.current) {
                                props.domref.current.innerHTML = "<div class='alert alert-warning'>Your subscription has already been cancelled.</div>";
                                setTimeout(() => { props.domref.current.innerHTML = ''; }, 5000);
                            }
                             setPlgCancelInfoLoading(false);
                            return;
                        }
                        setPlgCancelInfo(resp);
                        setShowPlgCancelModal(true);
                    } else {
                        const msg = (resp && resp.message) ? resp.message : 'Unable to load cancellation info. Please try again.';
                        if (props.domref && props.domref.current) {
                            props.domref.current.innerHTML = "<div class='alert alert-danger'>" + msg + "</div>";
                            setTimeout(() => { props.domref.current.innerHTML = ''; }, 4000);
                        }
                    }
                })
                .catch(() => {
                    setPlgCancelInfoLoading(false);
                    if (props.domref && props.domref.current) {
                        props.domref.current.innerHTML = "<div class='alert alert-danger'>Unable to load cancellation info. Please try again.</div>";
                        setTimeout(() => { props.domref.current.innerHTML = ''; }, 4000);
                    }
                });
            return;
        }
        setShowModal(true);
        setModelBody(<CancelBillingForm closeFunc={closePageModal} showTopMsg={showCancelSuccess}/>);
        setModelTitle("Cancel Request");
    }

    useImperativeHandle(ref, () => ({
        triggerCancel: () => cancelBilling(null),
        isCancelLoading: () => plgCancelInfoLoading,
        triggerAddCard: (e) => fetchzoholink(e || { preventDefault: () => {} }),
    }));


    const closePlgCancelModal = () => {
        setShowPlgCancelModal(false);
        setPlgCancelInfo(null);
        setCancelReason('');
        setCancelReasonOther('');
    }

    const confirmPlgCancellation = () => {
        setShowPlgCancelModal(false);
        setCancelReason('');
        setCancelReasonOther('');
        setCardState((prev) => ({ ...prev, loading: true }));
        const billingDetail = props.userBillingDetail;
        billing.plgCancelSubscription({
            subscription_id: billingDetail.subscription_id,
            user_id: props.user.user_id,
            subscription_status: 'ACTIVE',
            cancellation_reason: cancelReason,
            cancellation_reason_other: cancelReason === 'Other' ? cancelReasonOther.trim() : null,
        }).then((userResp) => {
            setCardState((prev) => ({ ...prev, loading: false }));
            if (userResp && userResp.msg === 'done') {
                props.billing_update();
                if (props.domref && props.domref.current) {
                    props.domref.current.innerHTML = "<div class='alert alert-success'>Your subscription has been cancelled.</div>";
                    setTimeout(() => { props.domref.current.innerHTML = ''; }, 5000);
                }
            } else if (userResp && userResp.msg === 'already_cancelled') {
                if (props.domref && props.domref.current) {
                    props.domref.current.innerHTML = "<div class='alert alert-warning'>Your subscription is already cancelled.</div>";
                    setTimeout(() => { props.domref.current.innerHTML = ''; }, 4000);
                }
            } else {
                const errMessage = (userResp && userResp.message) ? userResp.message : 'Unable to cancel subscription. Please try again.';
                if (props.domref && props.domref.current) {
                    props.domref.current.innerHTML = "<div class='alert alert-danger'>" + errMessage + "</div>";
                    setTimeout(() => { props.domref.current.innerHTML = ''; }, 4000);
                }
            }
        }).catch(() => {
            setCardState((prev) => ({ ...prev, loading: false }));
            if (props.domref && props.domref.current) {
                props.domref.current.innerHTML = "<div class='alert alert-danger'>Unable to cancel subscription. Please try again.</div>";
                setTimeout(() => { props.domref.current.innerHTML = ''; }, 4000);
            }
        });
    }

    const formatPhoneDisplay = (phone) => {
        if (!phone) return '';
        const digits = phone.replace(/\D/g, '');
        if (digits.length === 11 && digits.startsWith('1')) {
            const d = digits.slice(1);
            return `+1 (${d.slice(0,3)}) ${d.slice(3,6)}-${d.slice(6)}`;
        }
        if (digits.length === 10) {
            return `+1 (${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}`;
        }
        return phone;
    }

    const renderPlgCancelModal = () => {
        const rawPhone = (plgCancelInfo && plgCancelInfo.twilio_phone) ? plgCancelInfo.twilio_phone : '';
        const aiNumber = formatPhoneDisplay(rawPhone) || rawPhone;
        const planName = (plgCancelInfo && plgCancelInfo.plan_name) ? plgCancelInfo.plan_name : '';
        const nextBillingDate = (plgCancelInfo && plgCancelInfo.next_billing_date) ? plgCancelInfo.next_billing_date : '';
        const isInTrial = Boolean(plgCancelInfo && plgCancelInfo.is_in_trial);
        const trialEndsOn = (plgCancelInfo && plgCancelInfo.trial_ends_on) ? plgCancelInfo.trial_ends_on : '';
        if (!showPlgCancelModal) return null;

        const step = (n) => <span className="plg-cancel-modal__step-num">{n}</span>;
        const row = (n, text) => (
            <div className="plg-cancel-modal__step">
                {step(n)}
                <span className="plg-cancel-modal__step-text">{text}</span>
            </div>
        );
        const dialBox = (code, isPhone = false) => (
            <div className={`plg-cancel-modal__dial-box${isPhone ? ' plg-cancel-modal__dial-box--phone' : ''}`}>{code}</div>
        );
        const columnFooter = (text) => <p className="plg-cancel-modal__column-footer">{text}</p>;
        const carrierLogo = (src, alt) => (
            <img src={src} alt={alt} className="plg-cancel-modal__carrier-logo"/>
        );

        return (
            <div className="plg-cancel-modal">
                <div className="plg-cancel-modal__card">
                <div className="plg-cancel-modal__body">
                    <div className="plg-cancel-modal__header-row">
                        <div className="plg-cancel-modal__header-left">
                            <h2 className="plg-cancel-modal__title">
                                Cancel Subscription &amp; Remove Call Forwarding
                            </h2>
                            <p className="plg-cancel-modal__subtitle">
                                {isInTrial
                                    ? <>Your subscription will be <strong>cancelled immediately</strong> since you are still in your trial period{trialEndsOn ? ` (trial ends ${trialEndsOn})` : ''}.</>
                                    : <>Your subscription will remain active until the end of your current billing period{nextBillingDate ? ` (${nextBillingDate})` : ''}.</>
                                }
                            </p>
                            <p className="plg-cancel-modal__subtitle">
                                To ensure your calls continue routing correctly, you must remove call forwarding.
                            </p>
                        </div>

                        <div className="plg-cancel-modal__important">
                            <div className="plg-cancel-modal__important-head">
                                <i className="fa fa-info-circle" aria-hidden />
                                <strong>Important</strong>
                            </div>
                            <p>
                                If you cancel without removing call forwarding, calls may continue to be sent to this number once your subscription ends.
                            </p>
                        </div>
                    </div>

                    {aiNumber && (
                        <div className="plg-cancel-modal__ai-box">
                            <div className="plg-cancel-modal__ai-icon">
                                <i className="fa fa-phone-square" aria-hidden />
                            </div>
                            <div>
                                <div className="plg-cancel-modal__ai-label">AI Receptionist Number</div>
                                <div className="plg-cancel-modal__ai-number">{aiNumber}</div>
                                <div className="plg-cancel-modal__ai-note">This is the number currently receiving your forwarded calls.</div>
                            </div>
                        </div>
                    )}

                    <p className="plg-cancel-modal__instructions-title">
                        How to remove call forwarding and restore your normal voicemail
                    </p>
                    <p className="plg-cancel-modal__instructions-sub">
                        Dial the code below from the phone number you used to set up call forwarding to stop forwarding.
                    </p>

                    <div className="plg-cancel-modal__columns">
                        <div className="plg-cancel-modal__column plg-cancel-modal__column--verizon">
                            <div className="plg-cancel-modal__brand-logo-wrap" style={{marginTop:'10px',marginBottom:'10px'}}>
                                {carrierLogo(verizonLogo, 'Verizon')}
                            </div>
                            <p className="plg-cancel-modal__column-title">To restore Verizon voicemail:</p>
                            {row(1, 'Open your Phone app.')}
                            {row(2, 'Dial:')}
                            {dialBox('*73')}
                            {row(3, 'Tap Call.')}
                            {row(4, 'Wait for confirmation.')}
                            {columnFooter('Your calls will now return to Verizon voicemail.')}
                        </div>

                        <div className="plg-cancel-modal__column plg-cancel-modal__column--carriers">
                            <p className="plg-cancel-modal__column-title">
                                All other carriers (including Canada) and other mobile providers
                            </p>
                            <div className="plg-cancel-modal__carrier-logos">
                                {carrierLogo(attLogo, 'allcarrier')}

                            </div>
                            <p className="plg-cancel-modal__column-title">To restore your voicemail:</p>
                            {row(1, 'Open your Phone app.')}
                            {row(2, 'Dial:')}
                            {dialBox('##004#')}
                            {row(3, 'Tap Call.')}
                            {row(4, 'Wait for confirmation.')}
                            {columnFooter('Your calls will now return to your normal voicemail.')}
                        </div>

                        <div className="plg-cancel-modal__column plg-cancel-modal__column--voip">
                            <div className="plg-cancel-modal__voip-head">
                                <div className="plg-cancel-modal__voip-icon">
                                    <i className="fa fa-fax" aria-hidden />
                                </div>
                                <p className="plg-cancel-modal__column-title plg-cancel-modal__voip-title">
                                    Using a VoIP or Business Phone System?
                                </p>
                            </div>
                            <p className="plg-cancel-modal__voip-intro">
                                To stop calls from being sent to the AI Receptionist number:
                            </p>
                            {row(1, 'Log in to your phone system admin portal.')}
                            {row(2, 'Remove any call forwarding or call routing that sends calls to:')}
                            {aiNumber && dialBox(aiNumber, true)}
                            {row(3, 'Restore your previous routing or voicemail settings.')}
                            {columnFooter('After removing the AI number, calls will follow your normal business phone system rules.')}
                        </div>
                    </div>

                    <div className="plg-cancel-modal__reason-section">
                        <p className="plg-cancel-modal__reason-title">
                            Why are you cancelling?<span>*</span>
                        </p>
                        <ul className="plg-cancel-modal__reason-list">
                            {CANCEL_REASONS.map((reason) => (
                                <li key={reason}>
                                    <label className="plg-cancel-modal__reason-option">
                                        <input
                                            type="radio"
                                            name="plg-cancel-reason"
                                            value={reason}
                                            checked={cancelReason === reason}
                                            onChange={() => { setCancelReason(reason); setCancelReasonOther(''); }}
                                        />
                                        <span className="plg-cancel-modal__reason-option-label">{reason}</span>
                                    </label>
                                </li>
                            ))}
                        </ul>
                        {cancelReason === 'Other' && (
                            <div className="plg-cancel-modal__reason-other-wrap">
                                <textarea
                                    className="plg-cancel-modal__reason-other-textarea"
                                    placeholder="Please describe your reason..."
                                    maxLength={1000}
                                    value={cancelReasonOther}
                                    onChange={(e) => setCancelReasonOther(e.target.value)}
                                />
                                <div className="plg-cancel-modal__reason-other-meta">
                                    {cancelReasonOther.trim() === '' && (
                                        <span className="plg-cancel-modal__reason-other-error">Please enter a reason to continue.</span>
                                    )}
                                    <span className="plg-cancel-modal__reason-other-count">{cancelReasonOther.length}/1000</span>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="plg-cancel-modal__warning">
                        <i className="fa fa-exclamation-triangle" aria-hidden />
                        <span>
                            <strong>Important:</strong> Your subscription cancellation will not automatically remove call forwarding.
                            Follow the instructions above to ensure callers reach your normal voicemail or business phone system after service ends.
                        </span>
                    </div>
                </div>

                <div className="plg-cancel-modal__footer">
                    <button
                        type="button"
                        onClick={closePlgCancelModal}
                        className="plg-cancel-modal__keep-btn"
                    >
                        Keep Subscription
                    </button>
                    <button
                        type="button"
                        onClick={confirmPlgCancellation}
                        disabled={!cancelReason || (cancelReason === 'Other' && cancelReasonOther.trim() === '')}
                        className="btn linear-gradient yr-submitbtn plg-cancel-modal__continue-btn"
                    >
                        Continue Cancellation <i className="fa fa-chevron-right" style={{ fontSize: '12px' }} aria-hidden />
                    </button>
                </div>
                </div>{/* plg-cancel-modal__card */}
            </div>
        );
    }
    const showCancelSuccess=(msg)=>{
        closePageModal();
        props.domref.current.innerHTML = "<div class='alert alert-success'>Your ticket has been generated. We will get back to you soon.</div>";
        setTimeout(() => {
            props.domref.current.innerHTML = "";
        }, 3000);
    }
    //actionConfirmDialog perform action (delete card or set primary)
    const actionConfirmDialog = () => {
        const mode = cardState.confirmDialogMode || 'delete';

        if (mode === 'primary') {
            const card = cardState.deletecard;
            if (!card || !card.card_id) {
                setCardState({ ...cardState, showConfirmDialog: false, confirmDialogMode: 'delete' });
                return false;
            }
            setCardState({ ...cardState, showConfirmDialog: false, loading: true });
            setCardPrimary(card)
                .then(() => setCardsLIst())
                .catch((error) => {
                    showCardActionError(error.message || 'Unable to set primary card. Please try again.');
                    setCardState((prev) => ({ ...prev, loading: false, confirmDialogMode: 'delete' }));
                });
            return false;
        }

        setCardState({ ...cardState, showConfirmDialog: false, loading: true });
        let cardtodel1 = {
            card_id: cardState.deletecard.card_id,
            cust_id: cardState.deletecard.zoho_customer_id,
            user_id: props.user.user_id,
            card_number: cardState.deletecard.last_four_digits,
        };

        billing.delCreditCard(cardtodel1).then((userResp) => {
            if (userResp.msg == 'done') {
                // If only one card remains after deletion, auto-promote it to primary
                const remainingCards = cardState.cards.filter(
                    (c) => String(c.card_id) !== String(cardtodel1.card_id)
                );
                if (remainingCards.length === 1) {
                    setCardPrimary(remainingCards[0]).catch(() => {});
                }

                setCardsLIst();
                props.domref.current.innerHTML =
                    "<div class='alert alert-success' >Card deleted successfully.</div>";
                setTimeout(() => {
                    props.domref.current.innerHTML = '';
                }, 3000);
            } else {
                const errorMessage = userResp.message
                    ? userResp.message
                    : 'Unable to delete card. Please try again.';
                props.domref.current.innerHTML =
                    "<div class='alert alert-danger' >" + errorMessage + '</div>';
                setTimeout(() => {
                    props.domref.current.innerHTML = '';
                }, 3000);
                setCardState((prev) => ({
                    ...prev,
                    showConfirmDialog: false,
                    confirmDialogMode: 'delete',
                    loading: false,
                }));
            }
        }).catch(() => {
            setCardState((prev) => ({
                ...prev,
                confirmDialogMode: 'delete',
                loading: false,
            }));
        });
        return false;
    };

    const toggleConfirmDialog = () => {
        setCardState({ ...cardState, showConfirmDialog: false, confirmDialogMode: 'delete' });
        return false;
    };
    //card action button close
    let cardlistd = props.cardsList.cards;
    const cardListRender = () => {
        let crds=cardState.cards.slice().reverse();
        return(<>
            { crds.length ? crds.map(
                ( card ) => {
                    return (
                        <>
                            <tr key={card.card_id} className="table-tbody-row">
                                <td className="table-td-custom table-td-card-details">
                                    <div className="card-details-container">
                                        <img src={visaLogo} className="bill-card" alt="" />
                                        <div className="card-number">
                                            **** **** **** {card.last_four_digits}
                                        </div>
                                    </div>
                                </td>
                                <td className="table-td-custom table-td-expiry">
                                    <span>Expires on {card.expiry_month}/{card.expiry_year}</span>
                                </td>
                                <td className="table-td-custom table-td-status">
                                    {/* Single card is always primary; also primary when it matches default_card */}
                                    {(cardState.cards.length === 1 || String(card.last_four_digits) === String(props?.default_card)) ? (
                                        <span className="status-badge primary">Primary</span>
                                    ) : (
                                        Array.isArray(cardState.cards) && cardState.cards.length > 1 && (
                                            <button
                                                onClick={() => openSetPrimaryConfirm(card)}
                                                className="btn linear-gradient yr-submitbtn card-action-btn"
                                            >
                                                Mark as primary
                                            </button>
                                        )
                                    )}
                                </td>
                                <td className="table-td-custom table-td-card-actions">
                                    {cardActionButton(card)}
                                </td>
                            </tr>

                        </>
                    )
                }
                ) :
                <tr>
                    <td colSpan="4" className="empty-state-cell">
                        <i className="fa fa-credit-card empty-state-icon"></i>
                        <span className="empty-state-title">No payment methods found</span>
                        <span className="empty-state-subtitle">Click "Add a payment method" to add a new card</span>
                    </td>
                </tr>}
            </> );
    }
    //form add

    const formAddCard = ( formtype ) => {
        return <CardForms closepopup={()=>closeAddform()}
                reff={props.domref}
                form = {formtype}
                refresh={refresh}
                availcards={cardState.cards}
                setCardsLIst = {() => setCardsLIst()}
                closeModal = {() => closeModal()}
                user = {cardState.user} />;
    }
    //form add

    //function for closing model
    const closeModal = ( ) => {
        const newState = {...cardState,showModal : false };

        setCardState(newState);
        doRefresh(prev => prev + 1);

    }
    const closePageModal = ( ) => {
        setShowModal(false);
        setModelBody("");
        setModelTitle("");

    }
    // card modal
    const cardForm = ( ) => {
        return   (<Modal
            show={cardState.showModal}
            footer={""}
            onclose={closeModal}
            title={""}
            body={formAddCard( 'addForm' )}
        />)
    }

    const openFormModel = () => {
        setCardState({ ...cardState,showModal : !cardState.showModal })
    }
    const showCardLinkError = (pendingWindow) => {
        if (pendingWindow && !pendingWindow.closed) {
            pendingWindow.close();
        }

        seterrMsg("An error occurred.");
        setTimeout(() => {
            seterrMsg("");
        }, 3000);
    }

    const watchCardWindowClose = (cardWindow) => {
        const timer = setInterval(function(){
            if (cardWindow.closed && timer){
                clearInterval(timer);
                window.location.reload();
            }
        },1000);
    }

    const shouldPreOpenCardWindow = () => {
        const isNarrowScreen = window.matchMedia
            ? window.matchMedia('(max-width: 768px)').matches
            : window.innerWidth <= 768;
        const hasTouchInput = window.navigator.maxTouchPoints > 0;

        return isNarrowScreen || hasTouchInput;
    }

    const openCardLink = (link, pendingWindow) => {
        if (pendingWindow && !pendingWindow.closed) {
            try {
                pendingWindow.location.href = link;
                if (pendingWindow.focus) {
                    pendingWindow.focus();
                }
                watchCardWindowClose(pendingWindow);
                return;
            } catch (error) {
                window.location.href = link;
                return;
            }
        }

        const cardWindow = window.open(link,'Add Card','height=600,width=800');
        if (cardWindow) {
            if (window.focus) {
                cardWindow.focus();
            }
            watchCardWindowClose(cardWindow);
            return;
        }

        window.location.href = link;
    }

    const fetchzoholink=(e)=>{
        e.preventDefault();

        const pendingWindow = shouldPreOpenCardWindow()
            ? window.open('', '_blank')
            : null;

        billing
        .fetchzoholink({user_id:props.user.user_id})
        .then((userResp) => {
            if(userResp.status && userResp.link && userResp.link!=''){
                openCardLink(userResp.link, pendingWindow);
                return;
            }

            showCardLinkError(pendingWindow);
        }).catch(() => {
            showCardLinkError(pendingWindow);
        });
    }

    // Email validation function
    const validateEmail = (email) => {
        if (!email || email.trim() === '') {
            return 'Email address is required.';
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email.trim())) {
            return 'Please enter a valid email address.';
        }
        return '';
    }

    // Billing Emails functions
    const handleAddEmail = () => {
        setEmailInput('');
        setEditingEmailId(null);
        setEmailError('');
        setShowEmailModal(true);
    }

    // Common function to handle email API success response
    const handleEmailSuccess = (response, successMessage, errorMessage, isUpdate = false) => {
        console.log("response---", response);
        const isSuccess = isUpdate
            ? (response && response.status === true)
            : (response && (response.status === true || response.success === true || response.msg === 'success'));

        if (isSuccess) {
            fetchBillingEmails();
            closeEmailModal();
            seterrMsg("");
            if (props.domref && props.domref.current) {
                props.domref.current.innerHTML = "<div class='alert alert-success'>" + (response.message || successMessage) + "</div>";
                setTimeout(() => {
                    props.domref.current.innerHTML = "";
                }, 3000);
            }
        } else {
            setEmailError(response?.message || errorMessage);
        }
        setEmailLoading(false);
    }

    // Common function to handle email API error response
    const handleEmailError = (error, errorMessage, logAction) => {
        let errorMsg = errorMessage;

        // Log error details for debugging
        console.log(`${logAction} email error:`, error);
        console.log(`${logAction} email error response:`, error?.response);
        console.log(`${logAction} email error response data:`, error?.response?.data);

        // Extract error message from API response (for 409 and other error status codes)
        if (error?.response?.data?.message) {
            errorMsg = error.response.data.message;
            console.log(`Extracted error message from API: ${errorMsg}`);
        } else if (error?.message) {
            errorMsg = error.message;
        }

        setEmailError(errorMsg);
        setEmailLoading(false);
    }

    // Add new email function
    const handleAddEmailSave = () => {
        if (emailLoading) return;

        const validationError = validateEmail(emailInput);
        if (validationError) {
            setEmailError(validationError);
            return;
        }

        setEmailError('');
        seterrMsg('');
        setEmailLoading(true);

        billing.addBillingEmail({ email: emailInput })
            .then((response) => handleEmailSuccess(response, "Billing email added successfully.", "The provided email address is invalid or undeliverable.", false))
            .catch((error) => handleEmailError(error, "The provided email address is invalid or undeliverable.", "adding"));
    }

    // Update existing email function
    const handleUpdateEmail = () => {
        if (emailLoading) return;

        const validationError = validateEmail(emailInput);
        if (validationError) {
            setEmailError(validationError);
            return;
        }

        setEmailError('');
        seterrMsg('');
        setEmailLoading(true);

        billing.updateBillingEmail({ cbe_id: editingEmailId, email: emailInput })
            .then((response) => handleEmailSuccess(response, "Billing email updated successfully.", "The provided email address is invalid or undeliverable.", true))
            .catch((error) => handleEmailError(error, "The provided email address is invalid or undeliverable.", "updating"));
    }

    const closeEmailModal = () => {
        setShowEmailModal(false);
        setEmailInput('');
        setEditingEmailId(null);
        setEmailError('');
    }

    const handleEditEmail = (email) => {
        setEmailInput(email.email);
        setEditingEmailId(email.id);
        setShowEmailModal(true);
    }

    // Email Form for Modal
    const renderEmailForm = () => {
        return (
            <div className="email-form-container">
                <div className="email-form-field">
                    <label className="email-form-label">
                        Email
                    </label>
                    <input
                        type="email"
                        className={`form-control email-form-input ${emailError ? 'error' : ''}`}
                        placeholder="Enter email address (e.g., billing@company.com)"
                        value={emailInput}
                        onChange={(e) => {
                            setEmailInput(e.target.value);
                            // Clear error when user starts typing
                            if (emailError) {
                                setEmailError('');
                            }
                        }}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                editingEmailId !== null ? handleUpdateEmail() : handleAddEmailSave();
                            }
                        }}
                    />
                    {emailError && (
                        <div className="email-error-message">
                            <i className="fa fa-exclamation-circle email-error-icon"></i>
                            <span>{emailError}</span>
                        </div>
                    )}
                </div>
                <div className="email-form-actions">
                    <button
                        type="button"
                        onClick={closeEmailModal}
                        disabled={emailLoading}
                        className="btn linear-gradient-cancel yr-cancelbtn mg-r"
                    >
                        <span>Cancel</span>
                    </button>
                    <button
                        type="button"
                        onClick={() => editingEmailId !== null ? handleUpdateEmail() : handleAddEmailSave()}
                        disabled={emailLoading}
                        className="btn linear-gradient yr-submitbtn email-submit-button"
                    >
                        {emailLoading ? (
                            <>
                                <i className="fa fa-spinner fa-spin email-spinner"></i>
                                {editingEmailId ? 'Updating...' : 'Adding...'}
                            </>
                        ) : (
                            editingEmailId ? 'Update' : 'Save'
                        )}
                    </button>
                </div>
            </div>
        );
    }

    const handleDeleteEmail = (emailId) => {
        setEmailToDelete(emailId);
        setShowEmailDeleteConfirm(true);
    }

    const confirmDeleteEmail = () => {
        if (!emailToDelete) return;

        setShowEmailDeleteConfirm(false);
        setEmailLoading(true);
        billing.deleteBillingEmail({ cbe_id: emailToDelete })
            .then((response) => {
                if (response && (response.status === true || response.success === true || response.msg === 'success')) {
                    // Refresh the email list
                    fetchBillingEmails();
                    seterrMsg("");
                    setEmailToDelete(null);
                    // Show success message
                    if (props.domref && props.domref.current) {
                        props.domref.current.innerHTML = "<div class='alert alert-success'>" + (response.message || "Billing email deleted successfully.") + "</div>";
                        setTimeout(() => {
                            props.domref.current.innerHTML = "";
                        }, 3000);
                    }
                } else {
                    seterrMsg(response?.message || "Failed to delete email.");
                    setTimeout(() => {
                        seterrMsg("");
                    }, 3000);
                    setEmailLoading(false);
                    setEmailToDelete(null);
                }
            })
            .catch((error) => {
                console.error('Error deleting email:', error);
                seterrMsg(error?.response?.data?.message || "Failed to delete email.");
                setTimeout(() => {
                    seterrMsg("");
                }, 3000);
                setEmailLoading(false);
                setEmailToDelete(null);
            });
    }

    const cancelDeleteEmail = () => {
        setShowEmailDeleteConfirm(false);
        setEmailToDelete(null);
    }

    const renderBillingEmailsTable = () => {
        return (
            <div className="table-responsive table-responsive-custom">
                <table className="table table-borderless table-lg my-4 my-table table-custom">
                    <thead className="table-thead-custom">
                        <tr>
                            <th className="table-th-custom table-th-email">Emails</th>
                            <th className="table-th-custom table-th-actions">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {emailLoading ? (
                            <tr>
                                <td colSpan="4" className="loading-cell">
                                    <div className="ui loading form"></div>
                                </td>
                            </tr>
                        ) : billingEmails.length > 0 ? (
                            billingEmails.map((email, index) => (
                                <tr key={email.id} className="table-tbody-row">
                                    <td className="table-td-custom table-td-email" title={email.email}>{email.email}</td>

                                    <td className="table-td-custom table-td-actions">
                                            <span
                                                onClick={() => handleEditEmail(email)}
                                                className="action-icon-edit"
                                                title="Edit"
                                            >
                                                <i className="la la-edit action-icon-size blue"></i>
                                            </span>
                                            <span
                                                onClick={() => handleDeleteEmail(email.id)}
                                                className="action-icon-delete"
                                                title="Delete"
                                            >
                                                <i className="la la-trash action-icon-size"></i>
                                            </span>

                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="empty-state-cell">
                                    <i className="fa fa-envelope empty-state-icon"></i>
                                    <span className="empty-state-title">No billing emails found</span>
                                    <span className="empty-state-subtitle">Click "Add Email" to add a new billing email</span>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    }
    return (
        <>
            {errMsg.length>0 && (
                <div className="error-message-container">
                    <i className="fa fa-exclamation-circle"></i>
                    <span>{errMsg}</span>
                </div>
            )}

            {/* Tab Navigation */}
            <div className="tab-navigation-container">
                <ul className="nav nav-tabs tab-nav-list billing-tab-nav-list" role="tablist">
                    <li className="nav-item">
                        <a
                            className={`nav-link tab-nav-link ${activeTab === 'payment' ? 'active' : ''}`}
                            href="#payment-method"
                            data-toggle="tab"
                            role="tab"
                            onClick={(e) => {
                                e.preventDefault();
                                setActiveTab('payment');
                            }}
                        >

                            Payment Method
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className={`nav-link tab-nav-link tab-nav-link-billing ms-5 ${activeTab === 'billing-emails' ? 'active' : ''}`}
                            href="#billing-emails"
                            data-toggle="tab"
                            role="tab"
                            onClick={(e) => {
                                e.preventDefault();
                                setActiveTab('billing-emails');
                            }}
                        >

                            Billing Emails
                        </a>
                    </li>
                </ul>
                {(((!props.isPlgAccount || (!props.isInTrial && Boolean(props.plgPlan))) && !props.hideTabHeaderActions) || activeTab === 'billing-emails') && (
                    <div className="tab-header-actions">
                        {(!props.isPlgAccount || (!props.isInTrial && Boolean(props.plgPlan))) && !props.hideTabHeaderActions && (
                            <WatchPageTutorial
                                videoKey="billing"
                                className="watch-page-tutorial--inline-tab"
                            />
                        )}
                        {activeTab === 'payment' && (!props.isPlgAccount || (!props.isInTrial && Boolean(props.plgPlan))) && !props.hideTabHeaderActions && (
                            <button
                                type="button"
                                id="cancel-billing-btn"
                                className="btn linear-gradient yr-submitbtn action-button action-button-shadow"
                                onClick={(e) => cancelBilling(e)}
                                disabled={plgCancelInfoLoading || (props.isPlgAccount && !Boolean(props.userBillingDetail && props.userBillingDetail.subscription_id))}
                            >
                                {plgCancelInfoLoading
                                    ? <><i className="fa fa-spinner fa-spin" style={{ marginRight: '6px' }}></i>Loading...</>
                                    : <span>{props?.isPlgAccount ? 'Cancel Subscription' : 'Cancel'}</span>
                                }
                            </button>
                        )}
                        {activeTab === 'billing-emails' && (
                            <button
                                type="button"
                                onClick={handleAddEmail}
                                className="btn linear-gradient yr-submitbtn action-button action-button-shadow"
                            >
                                <i className="fa fa-plus"></i>
                                Add Email
                            </button>
                        )}
                    </div>
                )}
            </div>

            {/* Tab Content */}
            <div className="tab-content tab-content-container">
                {/* Payment Method Tab */}
                {activeTab === 'payment' && (
                    <div className="tab-pane active">
                        {cardForm()}

                        <div className="table-responsive table-responsive-custom">
                            <table className="table table-borderless table-lg my-4 my-table">
                                <thead className="table-thead-custom">
                                    <tr>
                                        <th className="table-th-custom">Details</th>
                                        <th className="table-th-custom">Expiry Date</th>
                                        <th className="table-th-custom">Status</th>
                                        <th className="table-th-custom">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="border-top">
                                    { cardState.loading  && (
                                        <tr>
                                            <td colSpan="4" className="loading-cell">
                                                <div className="ui loading form"></div>
                                            </td>
                                        </tr>
                                    )}
                                    { cardListRender()}
                                </tbody>
                            </table>
                        </div>
                        <div className="add-card-row">
                            <button
                                type="button"
                                onClick={(e) => fetchzoholink(e)}
                                className="btn linear-gradient yr-submitbtn action-button"
                            >
                                <i className="fa fa-plus"></i>
                                Add a payment method
                            </button>
                        </div>
                    </div>
                )}

                {/* Billing Emails Tab */}
                {activeTab === 'billing-emails' && (
                    <div className="tab-pane active">
                        {renderBillingEmailsTable()}
                    </div>
                )}
            </div>

            <ConfirmDialog
                show={cardState.showConfirmDialog}
                toggleModal={actionConfirmDialog}
                closeAction={toggleConfirmDialog}
                title={cardState.confirmtitle}
                message={cardState.confirmmessage}
            />

            <ConfirmDialog
                show={showEmailDeleteConfirm}
                toggleModal={confirmDeleteEmail}
                closeAction={cancelDeleteEmail}
                title="Delete Billing Email"
                message="Are you sure you want to delete this billing email? This action cannot be undone."
            />

            <Modal
                show={showModal}
                footer={""}
                onclose={closePageModal}
                title={modelTitle}
                body={modelBody}
                maxWidth={1000}
            />

            <Modal
                show={showEmailModal}
                footer={""}
                onclose={closeEmailModal}
                title={editingEmailId ? "Edit Billing Email" : "Add Billing Email"}
                body={renderEmailForm()}
                maxWidth={600}
            />

            {renderPlgCancelModal()}
        </>
    )

});
export default CreditCardList;